import { createApiConfig } from "./config";

import { SUPER_ADMIN_API_URL } from "./routes"

const apiConfig = createApiConfig();


// super admin crud

export const listAdminUser = () => apiConfig.get(SUPER_ADMIN_API_URL);

// CREATE superAdmin User

export const addAdminUser =  (data) => apiConfig.post(SUPER_ADMIN_API_URL, data);

// DELETE superAdmin User

export const deleteAdminUser = (id) => apiConfig.delete(`${SUPER_ADMIN_API_URL}/${id}`);

// Update superAdmin User

export const updateAdminUser = (data,id) => apiConfig.put(`${SUPER_ADMIN_API_URL}/${id}`, data);